/**
 * @legacy
 * @prev administration/templates/administration/server/smtp_queue.html
 */
document.getElementById('select_all').onclick = function () {
  var checkboxes = document.getElementsByName('entries')
  for (var checkbox of checkboxes) {
    checkbox.checked = this.checked
  }
}
